import { zocker } from 'zocker';
import { ZodSchema } from 'zod';

export const generateMockSchema = <T>(
  schema: ZodSchema<T>,
  override?: Partial<T>
): T => {
  const mockData = zocker(schema).generate();
  return { ...mockData, ...override };
};
